<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 custom-title">{{ sub_level_item.name }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section mt-2 mb-2" v-if="!loading_list">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">{{ $route.params.id == 0 ? 'District' : 'Zone' }}</th>
                            <th scope="col" class="text-center min-width">Report/<br>Schedule/<br>Election Report</th>
                            <th scope="col">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in sub_levels" v-bind:key="sub_level">
                            <td class=" text-primary font-dark">
                                {{ sub_level.name_mal ? sub_level.name_mal : sub_level.name }}({{ sub_level.members_count }})
                            </td>
                            <td class="text-center">
                                <span class="badge badge-primary" v-if="sub_level.consol_form_status_level == 1">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-success" v-if="sub_level.consol_form_status_level == 2">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-danger"
                                    v-if="sub_level.consol_form_status_level == 0 || sub_level.consol_form_status_level == 3">
                                    <ion-icon name="close-outline" class="icon-size20"></ion-icon>
                                </span>
                                /
                                <span class="badge badge-success"
                                    v-if="sub_level.election && sub_level.all_presiding_officers">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-primary"
                                    v-if="sub_level.election && !sub_level.all_presiding_officers">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-danger" v-if="!sub_level.election">
                                    <ion-icon name="close-outline" class="icon-size20"></ion-icon>
                                </span>
                                /
                                <span class="badge badge-primary" v-if="sub_level.election_status_level == 2">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-success"
                                    v-if="sub_level.election_status_level == 3 && sub_level.not_selected_wings == 0">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-warning"
                                    v-if="sub_level.election_status_level == 3 && sub_level.not_selected_wings > 0">
                                    <ion-icon name="checkmark-outline" class="icon-size20">
                                    </ion-icon>
                                </span>
                                <span class="badge badge-danger"
                                    v-if="sub_level.election_status_level <= 1 || sub_level.election_status_level == 4">
                                    <ion-icon name="close-outline" class="icon-size20"></ion-icon>
                                </span>
                            </td>
                            <td>
                                <button type="button" class="btn btn-link btn-icon ios-touch-fix" 
                                    @click="showNativeModal(sub_level)"
                                    @touchstart="handleTouchStart"
                                    @touchend="handleTouchEnd">
                                    <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                </button>
                                <div class="modal fade action-sheet" :id="'actionSheetInset' + sub_level.id" tabindex="-1"
                                    role="dialog">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Action</h5>
                                            </div>
                                            <div class="modal-body">
                                                <ul class="action-button-list">
                                                    <li v-if="permissions.consolidated_report?permissions.consolidated_report.view:false">
                                                        <a href="javascript:void(0)" class="btn btn-list mobile-action-btn"
                                                            @click="handleActionClick('goToConsReport', sub_level.id, this.user_level+1)"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span>
                                                                <ion-icon name="eye-outline"></ion-icon>
                                                                {{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} കൺസോളിഡേറ്റഡ്
                                                                റിപ്പോർട്ട്
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li
                                                        v-if="((currentUser.user_level <= 2 && currentUser.district_id == $route.params.id) || currentUser.user_level == 1) && (permissions.election_schedule?permissions.election_schedule.view:false)">
                                                        <a href="javascript:void(0)" class="btn btn-list mobile-action-btn"
                                                            @click="handleActionClick('goToScheduleElection', sub_level.id)"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span>
                                                                <ion-icon name="menu-outline"></ion-icon>
                                                                {{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} ഇലക്ഷൻ
                                                                ഷെഡ്യൂൾ
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li
                                                        v-if="((currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && $route.params.sub_level == 2)">
                                                        <a href="javascript:void(0)" class="btn btn-list mobile-action-btn"
                                                            @click="handleActionClick('goToCouncillorsList', sub_level.id)"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span class="mal-text">
                                                                <ion-icon name="globe-outline"></ion-icon>
                                                                ജില്ല/സംസ്ഥാന കൗൺസിലർമാർ
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li
                                                        v-if="(currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && (permissions.executive?permissions.executive.view:false)">
                                                        <a href="javascript:void(0)" class="btn btn-list mobile-action-btn"
                                                            @click="handleActionClick('goToElectionList', sub_level.id)"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span class="mal-text">
                                                                <ion-icon name="people-outline"></ion-icon>
                                                                {{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }}
                                                                എക്സിക്യൂട്ടീവ്/ ഭാരവാഹികൾ
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li
                                                        v-if="(currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && (permissions.executive_report?permissions.executive_report.view:false)">
                                                        <a href="javascript:void(0)" class="btn btn-list mobile-action-btn"
                                                            @click="handleActionClick('goToElectionReport', sub_level.id)"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span>
                                                                <ion-icon name="receipt-outline"></ion-icon>
                                                                {{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} ഇലക്ഷൻ
                                                                റിപ്പോർട്ട്
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="action-divider"></li>
                                                    <li>
                                                        <a href="javascript:void(0)" class="btn btn-list text-danger mobile-action-btn"
                                                            @click="handleActionClick('cancel')"
                                                            @touchstart="handleButtonTouch"
                                                            @touchend="handleButtonTouch">
                                                            <span>
                                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td class="text-end text-primary font-dark total-size">
                                Total
                            </td>
                            <td class="text-end text-primary font-dark total-size text-end">
                                {{(unit.members_count)}}
                            </td>
                            <td></td>
                            <td></td>
                        </tr> -->
                    </tbody>
                </table>
            </div>

        </div>
        <div class="card mt-2" v-if="$route.params.sub_level == 2">
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                        <tr>
                            <td class="text-primary text-end mal-text">
                                സ്റ്റാറ്റസ് :
                            </td>
                            <td colspan="3">
                                <strong class="mal-text text-secondary"
                                    v-if="sub_level_item.consol_form_status_level == 0">സ്റ്റേറ്റിലേക്ക്
                                    അയച്ചിട്ടില്ല</strong>
                                <strong class="mal-text text-primary"
                                    v-if="sub_level_item.consol_form_status_level == 1">സ്റ്റേറ്റിലേക്ക് അയച്ചു</strong>
                                <strong class="mal-text text-danger"
                                    v-if="sub_level_item.consol_form_status_level == 3">സ്റ്റേറ്റ്
                                    റിജെക്ട് ചെയ്തു</strong>
                                <strong class="mal-text text-success"
                                    v-if="sub_level_item.consol_form_status_level == 2">സ്റ്റേറ്റ്
                                    സ്വീകരിച്ചു</strong>
                            </td>
                        </tr>
                        <tr v-if="permissions.send_report">
                            <td colspan="4">
                                <a href="javascript:void(0)" data-bs-toggle="modal" @click="openSubmitModel"
                                    v-if="sub_level_item.consol_form_status_level == 0 || sub_level_item.consol_form_status_level == 3">
                                    <button
                                        class="btn btn-primary report-btn btn-accept-reject mal-text">സ്റ്റേറ്റിലേക്ക്
                                        അയക്കാൻ
                                        ഇവിടെ
                                        അമർത്തുക
                                        <ion-icon name="arrow-forward-outline"></ion-icon>
                                    </button>
                                </a>
                            </td>
                        </tr>
                        <tr v-if="permissions.accept_report || permissions.reject_report">
                            <td colspan="4">
                                <div class="row">
                                    <a href="javascript:void(0)" class="col-6"
                                        @click="acceptConsReport($route.params.id)" v-if="permissions.accept_report">
                                        <button
                                            class="btn btn-primary btn-accept-reject report-btn-success report-btn mal-text">സ്വീകരിക്കാൻ
                                            ഇവിടെ അമർത്തുക
                                            <ion-icon name="arrow-forward-outline"></ion-icon>
                                        </button>
                                    </a>
                                    <a href="javascript:void(0)" :class="permissions.accept_report ? 'col-6' : 'col-12'"
                                        @click="rejectConsReport($route.params.id)" v-if="permissions.reject_report">
                                        <button
                                            class="btn btn-danger btn-accept-reject report-btn-success report-btn mal-text">
                                            റിജെക്ട് ചെയ്യാൻ
                                            ഇവിടെ അമർത്തുക
                                            <ion-icon name="arrow-forward-outline"></ion-icon>
                                        </button>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
    <!-- <ul class="listview image-listview inset text" v-if="!loading_list">
        <li v-for="sub_level in sub_levels" v-bind:key="sub_level.id">
            <a class="item">
                <div class="in">
                    <div>
                        <b class="list-title">{{ sub_level.name }}</b>
                        <footer>
                            <div class="chip chip-media mt-1">
                                <i class="chip-icon bg-secondary">Status</i>
                                <span class="chip-label">{{
                                sub_level.consol_form_status
                                }}</span>
                            </div>
                        </footer>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset'+sub_level.id">
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>

                    <div class="modal fade action-sheet" :id="'actionSheetInset'+sub_level.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li>
                                            <a href="javascript:void(0)" class="btn btn-list"
                                                @click="goToConsReport(sub_level.id)" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="eye-outline"></ion-icon> View Consolidated Sheet
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </ul> -->
    <div class="modal fade action-sheet" id="actionSheetForm" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Action</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="mb-1 col-12 mal-text text-center text-primary" v-if="permissions.ready_to_send">
                            <span class="badge badge-success">
                                <ion-icon name="checkmark-outline" class="icon-size20">
                                </ion-icon>
                            </span>
                            എന്റെ ജില്ലയിലെ എല്ലാ മണ്ഡലത്തിന്റെയും 2025 വർഷത്തെ ഇലക്ഷൻ പ്രവർത്തനം അവസാനിച്ചു.
                        </div>
                        <div class="mb-1 col-12 mal-text text-center text-warning" v-if="!permissions.ready_to_send">
                            <span class="badge badge-warning">
                                <ion-icon name="alert-outline"></ion-icon>
                            </span>
                            നിങ്ങളുടെ ജില്ലയിലെ ഇലക്ഷൻ റിപ്പോർട്ട് പൂർത്തിയായിട്ടില്ല.
                        </div>
                        <div class="text-danger text-center">{{ message }}</div>
                        <div class="form-group basic" v-if="permissions.ready_to_send">
                            <button type="button" class="btn btn-primary btn-block btn-lg"
                                :disabled="!permissions.ready_to_send" data-bs-dismiss="modal"
                                @click="submitToParentLevel(user_level_id)">Submit</button>
                        </div>
                        <div class="form-group basic" v-else>
                            <button type="button" class="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal"
                                @click="closeSubmitModel()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
    
    <!-- Native Vue Modal for Mobile -->
    <div v-if="showModal" class="native-modal-overlay" @click="closeNativeModal" @touchstart="closeNativeModal">
        <div class="native-modal-content" @click.stop @touchstart.stop>
            <div class="native-modal-header">
                <h5>Action</h5>
            </div>
            <div class="native-modal-body">
                <ul class="action-button-list">
                    <li v-if="permissions.consolidated_report?.view">
                        <a href="javascript:void(0)" class="btn btn-list"
                           @click="executeAction('goToConsReport', selectedSubLevel.id, user_level+1)"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="eye-outline"></ion-icon>{{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} കൺസോളിഡേറ്റഡ് റിപ്പോർട്ട്
                            </span>
                        </a>
                    </li>
                    
                    <li v-if="((currentUser.user_level <= 2 && currentUser.district_id == $route.params.id) || currentUser.user_level == 1) && permissions.election_schedule?.view">
                        <a href="javascript:void(0)" class="btn btn-list"
                           @click="executeAction('goToScheduleElection', selectedSubLevel.id)"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="menu-outline"></ion-icon>{{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} ഇലക്ഷൻ ഷെഡ്യൂൾ
                            </span>
                        </a>
                    </li>
                    
                    <li v-if="((currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && $route.params.sub_level == 2)">
                        <a href="javascript:void(0)" class="btn btn-list"
                           @click="executeAction('goToCouncillorsList', selectedSubLevel.id)"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="globe-outline"></ion-icon>ജില്ല/സംസ്ഥാന കൗൺസിലർമാർ
                            </span>
                        </a>
                    </li>
                    
                    <li v-if="(currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && permissions.executive?.view">
                        <a href="javascript:void(0)" class="btn btn-list"
                           @click="executeAction('goToElectionList', selectedSubLevel.id)"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="people-outline"></ion-icon>{{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} എക്സിക്യൂട്ടീവ്/ ഭാരവാഹികൾ
                            </span>
                        </a>
                    </li>
                    
                    <li v-if="(currentUser.user_level <= 2 && currentUser.district_id == $route.params.id || currentUser.user_level == 1) && permissions.executive_report?.view">
                        <a href="javascript:void(0)" class="btn btn-list"
                           @click="executeAction('goToElectionReport', selectedSubLevel.id)"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="receipt-outline"></ion-icon>{{ $route.params.id == 0 ? 'ജില്ല' : 'മണ്ഡലം' }} ഇലക്ഷൻ റിപ്പോർട്ട്
                            </span>
                        </a>
                    </li>
                    
                    <li class="action-divider"></li>
                    
                    <li>
                        <a href="javascript:void(0)" class="btn btn-list text-danger"
                           @click="closeNativeModal"
                           @touchstart="handleNativeTouch"
                           @touchend="handleNativeTouch">
                            <span>
                                <ion-icon name="close-outline"></ion-icon> Cancel
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: 'Reports',
    components: {
        AlertModel,
        DialogModel
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            permissions: [],
            message: "",
            country_code: '91',
            mobile_number: '',
            wing: '',
            user_level: "",
            user_level_id:"",
            sub_levels: [],
            admin_lists: [],
            unit: [],
            editable_id: '',
            editable: true,
            add_admin: false,
            district: '',
            total: 0.00,
            sub_level_item: [],

            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            
            // Native modal data
            showModal: false,
            selectedSubLevel: null
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.user_level_id = parseInt(this.$route.params.id);
            this.getReport();
            if (this.user_level == this.currentUser.user_level) {
                this.editable = false;
            } else {
                this.editable = true;
            }
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
        
        // Initialize iOS modal fixes after component is mounted
        this.$nextTick(() => {
            this.initializeIOSModalFixes();
        });
    },
    methods: {
        // Mobile Modal Fix - Explicit modal handling for iOS and Android
        openActionSheet(sublevelId) {
            console.log('Opening action sheet for:', sublevelId); // Debug log
            
            // Find the selected sub level
            const selectedSubLevel = this.sub_levels.find(item => item.id === sublevelId);
            
            if (this.isMobileDevice()) {
                // Use native modal for mobile devices
                this.showNativeModal(selectedSubLevel);
                return;
            }
            
            // Use Bootstrap modal for desktop
            const modalId = '#actionSheetInset' + sublevelId;
            const modalElement = $(modalId);
            
            if (modalElement.length === 0) {
                console.error('Modal element not found:', modalId);
                return;
            }
            
            // Close any existing modals first
            $('.modal').modal('hide');
            $('.modal-backdrop').remove();
            
            // Mobile specific fixes
            if (this.isMobileDevice()) {
                // Prevent body scroll on mobile
                $('body').css({
                    'overflow': 'hidden',
                    'position': 'fixed',
                    'width': '100%',
                    'height': '100%'
                });
                
                // Add mobile specific classes
                modalElement.addClass('mobile-modal-fix');
                
                // iOS specific aggressive fixes
                if (this.isIOS()) {
                    modalElement.css({
                        'position': 'fixed',
                        'top': '0',
                        'left': '0',
                        'width': '100%',
                        'height': '100%',
                        'z-index': '99999'
                    });
                }
            }
            
            // Show modal with custom configuration
            modalElement.modal({
                backdrop: false, // Disable backdrop for iOS
                keyboard: true,
                focus: true,
                show: true
            });
            
            // Create custom backdrop for iOS
            if (this.isIOS()) {
                const customBackdrop = $('<div class="custom-modal-backdrop"></div>');
                customBackdrop.css({
                    'position': 'fixed',
                    'top': '0',
                    'left': '0',
                    'width': '100%',
                    'height': '100%',
                    'background-color': 'rgba(0,0,0,0.5)',
                    'z-index': '99998'
                });
                
                customBackdrop.on('click touchstart', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.closeActionSheet(modalElement, customBackdrop);
                });
                
                $('body').append(customBackdrop);
            }
            
            // Ensure modal is properly positioned
            setTimeout(() => {
                // Fix modal positioning for mobile devices
                if (this.isMobileDevice()) {
                    modalElement.find('.modal-dialog').css({
                        'position': 'fixed',
                        'bottom': '0',
                        'left': '0',
                        'right': '0',
                        'margin': '0',
                        'transform': 'translateY(0)',
                        'max-width': 'none',
                        'width': '100%',
                        'z-index': '99999'
                    });
                    
                    modalElement.find('.modal-content').css({
                        'border-radius': '20px 20px 0 0',
                        'border': 'none',
                        'box-shadow': '0 -10px 30px rgba(0,0,0,0.3)'
                    });
                    
                    // Make sure modal content is clickable with more aggressive settings
                    modalElement.find('.mobile-action-btn').css({
                        'position': 'relative',
                        'z-index': '100001',
                        'display': 'block',
                        'padding': '15px 20px',
                        'background': 'white',
                        'cursor': 'pointer',
                        'border': 'none',
                        'outline': 'none',
                        'pointer-events': 'auto',
                        '-webkit-tap-highlight-color': 'rgba(0,0,0,0.15)'
                    });
                    
                    // Force pointer events on all action buttons
                    modalElement.find('.action-button-list li').css({
                        'pointer-events': 'auto',
                        'position': 'relative',
                        'z-index': '100000'
                    });
                    
                    // Add direct event listeners for iOS if click events are not working
                    if (this.isIOS()) {
                        modalElement.find('.mobile-action-btn').each(function() {
                            const button = $(this);
                            
                            // Add touchstart listener as backup
                            button.off('touchstart.mobileFix').on('touchstart.mobileFix', function(e) {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                $(this).addClass('btn-pressing');
                                
                                // Execute click after short delay
                                setTimeout(() => {
                                    $(this).removeClass('btn-pressing');
                                    $(this).trigger('click');
                                }, 100);
                            });
                        });
                    }
                }
            }, 100);
            
            // Handle modal close event
            modalElement.off('hidden.bs.modal').on('hidden.bs.modal', () => {
                this.cleanupModal();
            });
        },
        
        // Close action sheet method
        closeActionSheet(modalElement, customBackdrop) {
            modalElement.modal('hide');
            if (customBackdrop) {
                customBackdrop.remove();
            }
            this.cleanupModal();
        },
        
        // Cleanup modal method
        cleanupModal() {
            if (this.isMobileDevice()) {
                $('body').css({
                    'overflow': '',
                    'position': '',
                    'width': '',
                    'height': ''
                });
                $('.mobile-modal-fix').removeClass('mobile-modal-fix');
                $('.custom-modal-backdrop').remove();
                $('.modal-backdrop').remove();
            }
        },
        
        // Detect mobile devices (iOS and Android)
        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                   (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },
        
        // Initialize mobile modal fixes
        initializeIOSModalFixes() {
            if (this.isMobileDevice()) {
                // Add mobile class to body for additional styling
                $('body').addClass('mobile-device');
                
                // Prevent mobile zoom on input focus (if needed)
                $('input, select, textarea').attr('autocomplete', 'off');
                
                // Fix viewport for mobile browsers
                if (window.DeviceMotionEvent && 'ontouchstart' in window) {
                    const viewport = document.querySelector('meta[name=viewport]');
                    if (viewport) {
                        viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
                    }
                }
                
                // Fix touch events for mobile
                $(document).on('touchstart', '.action-button-list li a', function() {
                    $(this).addClass('touching');
                });
                
                $(document).on('touchend touchcancel', '.action-button-list li a', function() {
                    $(this).removeClass('touching');
                });
                
                // Force enable touch events on iOS
                if (this.isIOS()) {
                    document.addEventListener('touchstart', function() {}, true);
                }
            }
        },
        
        // Handle touch events for iOS buttons
        handleTouchStart(event) {
            if (this.isMobileDevice()) {
                event.currentTarget.classList.add('btn-touching');
            }
        },
        
        handleTouchEnd(event) {
            if (this.isMobileDevice()) {
                event.currentTarget.classList.remove('btn-touching');
            }
        },
        
        // Detect iOS specifically
        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                   (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },
        
        // Handle action button clicks with manual modal closure
        handleActionClick(action, ...params) {
            console.log('Action clicked:', action, params);
            
            // Close all modals first
            $('.modal').modal('hide');
            this.cleanupModal();
            
            // Small delay to ensure modal is closed before navigation
            setTimeout(() => {
                switch(action) {
                    case 'goToConsReport':
                        this.goToConsReport(params[0], params[1]);
                        break;
                    case 'goToScheduleElection':
                        this.goToScheduleElection(params[0]);
                        break;
                    case 'goToCouncillorsList':
                        this.goToCouncillorsList(params[0]);
                        break;
                    case 'goToElectionList':
                        this.goToElectionList(params[0]);
                        break;
                    case 'goToElectionReport':
                        this.goToElectionReport(params[0]);
                        break;
                    case 'cancel':
                        // Modal already closed above
                        break;
                }
            }, 100);
        },
        
        // Handle button touch events for visual feedback
        handleButtonTouch(event) {
            if (event.type === 'touchstart') {
                event.currentTarget.classList.add('btn-pressing');
            } else if (event.type === 'touchend') {
                event.currentTarget.classList.remove('btn-pressing');
            }
        },
        
        // Native Modal Methods
        showNativeModal(subLevel) {
            console.log('Opening native modal for:', subLevel);
            this.selectedSubLevel = subLevel;
            this.showModal = true;
            
            // Prevent body scroll
            if (this.isMobileDevice()) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
                document.body.style.height = '100%';
            }
        },
        
        closeNativeModal() {
            this.showModal = false;
            this.selectedSubLevel = null;
            
            // Restore body scroll
            if (this.isMobileDevice()) {
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
                document.body.style.height = '';
            }
        },
        
        executeAction(action, ...params) {
            console.log('Executing action:', action, params);
            this.closeNativeModal();
            
            // Small delay to ensure modal is closed
            setTimeout(() => {
                switch(action) {
                    case 'goToConsReport':
                        this.goToConsReport(params[0], params[1]);
                        break;
                    case 'goToScheduleElection':
                        this.goToScheduleElection(params[0]);
                        break;
                    case 'goToCouncillorsList':
                        this.goToCouncillorsList(params[0]);
                        break;
                    case 'goToElectionList':
                        this.goToElectionList(params[0]);
                        break;
                    case 'goToElectionReport':
                        this.goToElectionReport(params[0]);
                        break;
                }
            }, 100);
        },
        
        handleNativeTouch(event) {
            if (event.type === 'touchstart') {
                if (event.currentTarget) {
                    event.currentTarget.classList.add('touching');
                }
            } else if (event.type === 'touchend') {
                setTimeout(() => {
                    if (event.currentTarget) {
                        event.currentTarget.classList.remove('touching');
                    }
                }, 150);
            }
        },
        getReport() {
            this.loading_list = true;
            let data = {
                id: parseInt(this.$route.params.id),
                sub_level: this.user_level + 1
            }
            UserService.authPostRequest('get-cons-election-report', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.sub_levels = response.data.data.list;
                        this.total = response.data.data.total;
                        this.sub_level_item = response.data.data.sub_level;
                        this.permissions = response.data.data.permissions;
                        this.$root.updateParent('ഇലക്ഷൻ റിപ്പോർട്ട്');
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading_list = true;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        goToConsReport(id,level = null) {
            if(level == 2){
                this.$router.push('/org/2/' + id + '/election-cons-report');
            }else{
                this.$router.push('/org/3/' + id + '/zone-cons-report');
            }
            
        },
        goToScheduleElection(id) {
            this.$router.push('/org/' + (this.user_level + 1) + '/' + id + '/sub-level-schedule-election');
        },
        goToElectionReport(id) {
            this.$router.push('/org/' + (this.user_level + 1) + '/' + id + '/org-excecutive-report');
        },
        goToElectionList(id) {
            this.$router.push('/org/' + (this.user_level + 1) + '/' + id + '/org-excecutive-list');
        },
        goToCouncillorsList(id) {
            this.$router.push('/org/' + (this.user_level + 1) + '/' + id + '/org-councilers-list');
        },
        openSubmitModel() {
            this.message = '';
            this.openMobileModal('#actionSheetForm');
        },
        closeSubmitModel() {
            this.closeMobileModal('#actionSheetForm');
        },
        
        // Generic mobile modal handling methods
        openMobileModal(modalId) {
            const modalElement = $(modalId);
            
            // Close any existing modals first
            $('.modal').modal('hide');
            $('.modal-backdrop').remove();
            $('.custom-modal-backdrop').remove();
            
            // Mobile specific fixes
            if (this.isMobileDevice()) {
                // Prevent body scroll on mobile
                $('body').css({
                    'overflow': 'hidden',
                    'position': 'fixed',
                    'width': '100%',
                    'height': '100%'
                });
                
                // Add mobile specific classes
                modalElement.addClass('mobile-modal-fix');
                
                // iOS specific fixes
                if (this.isIOS()) {
                    modalElement.css({
                        'position': 'fixed',
                        'top': '0',
                        'left': '0',
                        'width': '100%',
                        'height': '100%',
                        'z-index': '99999'
                    });
                }
            }
            
            // Show modal with custom configuration
            modalElement.modal({
                backdrop: this.isIOS() ? false : true,
                keyboard: true,
                focus: true,
                show: true
            });
            
            // Create custom backdrop for iOS
            if (this.isIOS()) {
                const customBackdrop = $('<div class="custom-modal-backdrop"></div>');
                customBackdrop.on('click touchstart', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.closeMobileModal(modalId);
                });
                $('body').append(customBackdrop);
            }
            
            // Handle modal close event
            modalElement.off('hidden.bs.modal').on('hidden.bs.modal', () => {
                this.cleanupModal();
            });
        },
        
        closeMobileModal(modalId) {
            const modalElement = $(modalId);
            modalElement.modal('hide');
            this.cleanupModal();
        },
        submitToParentLevel(id) {
            this.message = '';
            var data = {
                id: id,
                sub_level: this.user_level,
            }
            UserService.authPostRequest('submit-cons-to-parent-level', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.closeMobileModal('#actionSheetForm');
                        this.permissions = response.data.data.permissions;
                        this.unit = response.data.data.zone;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.response.data.message;
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                }
            );
        },
        acceptConsReport(id) {
            var data = {
                id: id,
                sub_level: this.user_level,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും സ്വീകരിക്കണോ?';
            this.dialog_action = 'acceptConsReportSuccess';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        acceptConsReportSuccess(data) {
            UserService.authPostRequest('accept-cons-report', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.closeMobileModal('#actionSheetForm');
                        this.permissions = response.data.data.permissions;
                        this.unit = response.data.data.zone;
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.response.data.message;
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                }
            );
        },

        rejectConsReport(id) {
            var data = {
                id: id,
                sub_level: this.user_level,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും റിജെക്ട് ചെയ്യണോ?';
            this.dialog_action = 'rejectConsReportSuccess';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        rejectConsReportSuccess(data) {
            UserService.authPostRequest('reject-cons-report', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.closeMobileModal('#actionSheetForm');
                        this.alert_type = 'Success';
                        this.permissions = response.data.data.permissions;
                        this.unit = response.data.data.zone;
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.response.data.message;
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                }
            );
        },

    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.list-title {
    font-size: 16px;
}

.footer_div {
    display: inline-block;
    margin-left: 3px;
}

.first_span {
    margin-right: 5px;
}

.text-only {
    font-size: 13px;
    font-weight: bold;
    color: black;
    /* margin-right: 5px; */
}

.font-dark {
    font-weight: 500;
}

.total-size {
    font-size: 18px;
}

.report-btn-success {
    width: 100%;
}


.wallet-footer-user {
    height: 46px !important;
}

.chip-media {
    margin-left: 5px;
    width: 135px !important;
    padding-left: 25px !important;
}

.chip-icon {
    width: 50px !important;
}

.chip-label {
    padding: 0px 30px 0px 30px !important;
    font-size: 14px !important;
}

.btn-icon {
    height: 22px !important;
}

.min-width {
    min-width: 124px !important;
}

/* iOS Modal Fix */
.modal-backdrop {
    z-index: 1040 !important;
}

.modal {
    z-index: 1050 !important;
}

.action-sheet .modal-dialog {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.action-sheet.show .modal-dialog {
    transform: translateY(0);
}

/* Mobile specific fixes */
@supports (-webkit-touch-callout: none) {
    .modal-backdrop {
        position: fixed !important;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1050 !important;
    }
    
    .modal {
        -webkit-overflow-scrolling: touch;
        position: fixed !important;
        z-index: 1055 !important;
    }
    
    .action-button-list li a {
        -webkit-tap-highlight-color: rgba(0,0,0,0.1);
        cursor: pointer;
        position: relative;
        z-index: 1;
        display: block;
        padding: 15px 20px;
        touch-action: manipulation;
        min-height: 50px;
    }
    
    .mobile-modal-fix {
        position: fixed !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1055 !important;
    }
    
    .mobile-modal-fix .modal-dialog {
        position: fixed !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        max-width: none !important;
    }
}

/* Android specific fixes */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
    .modal {
        position: fixed !important;
        z-index: 1055 !important;
    }
    
    .modal-backdrop {
        z-index: 1050 !important;
    }
    
    .action-button-list li a {
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0,0,0,0.1);
        touch-action: manipulation;
    }
}

/* Additional button styling for better touch targets */
.btn-icon {
    min-width: 44px !important;
    min-height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0,0,0,0.1);
    position: relative;
    z-index: 10;
}

/* iOS specific button fixes */
.ios-touch-fix {
    cursor: pointer !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0.2) !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

.btn-touching {
    background-color: rgba(0,0,0,0.1) !important;
    transform: scale(0.98);
    transition: all 0.1s ease;
}

/* Custom backdrop for iOS */
.custom-modal-backdrop {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: rgba(0,0,0,0.5) !important;
    z-index: 99998 !important;
}

/* Mobile device specific styles */
.mobile-device .modal {
    position: fixed !important;
    z-index: 1055 !important;
}

.mobile-device .modal-backdrop {
    position: fixed !important;
    z-index: 1050 !important;
}

.mobile-device .action-sheet {
    z-index: 1055 !important;
}

.mobile-device .action-sheet .modal-dialog {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: none !important;
}

/* Improve touch interactions */
.action-button-list li {
    touch-action: manipulation;
}

.action-button-list li a {
    min-height: 50px;
    display: flex;
    align-items: center;
    padding: 15px 20px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0,0,0,0.1);
    transition: background-color 0.2s ease;
}

.action-button-list li a:hover,
.action-button-list li a.touching {
    background-color: rgba(0,0,0,0.05);
}

/* Mobile action button specific styles */
.mobile-action-btn {
    cursor: pointer !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0.15) !important;
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    user-select: none !important;
    position: relative !important;
    z-index: 100001 !important;
    background: white !important;
    border: none !important;
    outline: none !important;
}

.mobile-action-btn:active,
.mobile-action-btn.btn-pressing {
    background-color: rgba(0,0,0,0.1) !important;
    transform: scale(0.98);
    transition: all 0.1s ease;
}

.mobile-action-btn:focus {
    outline: none !important;
    box-shadow: none !important;
}

.action-button-list li a span {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

/* Force proper modal positioning on mobile */
@media screen and (max-width: 768px) {
    .modal.action-sheet {
        padding: 0 !important;
    }
    
    .modal.action-sheet .modal-dialog {
        position: fixed !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        max-width: none !important;
        transform: none !important;
    }
    
    .modal.action-sheet .modal-content {
        border-radius: 20px 20px 0 0 !important;
        border: none !important;
    }
}

/* iOS Safari specific fixes */
@supports (-webkit-appearance: none) {
    .mobile-modal-fix {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        z-index: 99999 !important;
        overflow: hidden !important;
    }
    
    .mobile-modal-fix .modal-dialog {
        position: fixed !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        max-width: none !important;
        z-index: 100000 !important;
    }
    
    .mobile-modal-fix .action-button-list li a {
        -webkit-tap-highlight-color: rgba(0,0,0,0.1) !important;
        position: relative !important;
        z-index: 100001 !important;
        display: block !important;
        background: white !important;
        cursor: pointer !important;
    }
}

/* Prevent iOS zoom and scrolling issues */
@media screen and (-webkit-min-device-pixel-ratio: 2) {
    .mobile-device {
        -webkit-text-size-adjust: 100%;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        user-select: none;
    }
    
    .btn-icon {
        -webkit-tap-highlight-color: rgba(0,0,0,0.2) !important;
        -webkit-touch-callout: none !important;
        outline: none !important;
    }
    
    .action-button-list li a {
        -webkit-tap-highlight-color: rgba(0,0,0,0.1) !important;
        -webkit-touch-callout: none !important;
        cursor: pointer !important;
        outline: none !important;
    }
    
    .mobile-action-btn {
        -webkit-tap-highlight-color: rgba(0,0,0,0.15) !important;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        user-select: none !important;
        pointer-events: auto !important;
        cursor: pointer !important;
        position: relative !important;
        z-index: 100001 !important;
    }
}

/* Force clickable buttons in iOS Safari */
.mobile-modal-fix .mobile-action-btn {
    pointer-events: auto !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0.15) !important;
    cursor: pointer !important;
    z-index: 100001 !important;
    position: relative !important;
    display: block !important;
}

/* iOS Safari specific button fix */
@supports (-webkit-appearance: none) and (not (-ms-ime-align: auto)) {
    .mobile-action-btn {
        -webkit-appearance: none !important;
        appearance: none !important;
        -webkit-tap-highlight-color: rgba(0,0,0,0.15) !important;
        pointer-events: auto !important;
        cursor: pointer !important;
        touch-action: manipulation !important;
    }
}

/* Native Modal Styles - Matching Original Bootstrap Design */
.native-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    animation: fadeIn 0.3s ease;
}

.native-modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 400px;
    border-radius: 0.5rem 0.5rem 0 0;
    animation: slideUp 0.3s ease;
    box-shadow: 0 -0.5rem 1rem rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.native-modal-header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #dee2e6;
    background-color: #ffffff;
    text-align: center;
    border-radius: 0.5rem 0.5rem 0 0;
}

.native-modal-header h5 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
    color: #212529;
    line-height: 1.5;
}

.native-modal-body {
    padding: 0;
    background-color: #ffffff;
}

/* Native modal uses same structure as Bootstrap modal */
.native-modal-overlay .action-button-list {
    list-style: none;
    margin: 0;
    padding: 0;
    background-color: #ffffff;
}

.native-modal-overlay .action-button-list li {
    border-bottom: 1px solid #e9ecef;
    background-color: #ffffff;
}

.native-modal-overlay .action-button-list li:last-child {
    border-bottom: none;
}

.native-modal-overlay .action-button-list li.action-divider {
    background-color: #f8f9fa;
    border: none;
    margin: 0;
}

.native-modal-overlay .action-button-list li a {
    display: flex;
    align-items: center;
    padding: 0.875rem 1.5rem;
    color: #212529;
    text-decoration: none;
    min-height: 56px;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
    background-color: #ffffff;
    border: none;
    width: 100%;
    text-align: left;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    touch-action: manipulation;
}

.native-modal-overlay .action-button-list li a:hover,
.native-modal-overlay .action-button-list li a:focus {
    background-color: #f8f9fa;
    color: #212529;
}

.native-modal-overlay .action-button-list li a.text-danger {
    color: #dc3545 !important;
}

.native-modal-overlay .action-button-list li a.text-danger:hover {
    background-color: #f5f5f5;
    color: #dc3545 !important;
}

.native-modal-overlay .action-button-list li a span {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
}

.native-modal-overlay .action-button-list li a span ion-icon {
    font-size: 1.25rem;
    flex-shrink: 0;
    color: #6c757d;
}

.native-modal-overlay .action-button-list li a.text-danger span ion-icon {
    color: #dc3545;
}

/* Touch feedback */
.native-modal-overlay .action-button-list li a.touching,
.native-modal-overlay .action-button-list li a:active {
    background-color: #e9ecef;
    transform: none;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

/* Mobile optimizations */
@media screen and (max-width: 768px) {
    .native-modal-overlay {
        z-index: 999999 !important;
    }
    
    .native-modal-content {
        max-width: 100%;
        margin: 0;
        border-radius: 0.5rem 0.5rem 0 0;
    }
    
    .native-modal-overlay .action-button-list li a {
        padding: 1rem 1.5rem;
        min-height: 56px;
        font-size: 1rem;
    }
    
    .native-modal-overlay .action-button-list li a span ion-icon {
        font-size: 1.25rem;
    }
}

/* iOS specific enhancements */
@supports (-webkit-touch-callout: none) {
    .native-modal-overlay {
        -webkit-overflow-scrolling: touch;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
    
    .native-modal-overlay .action-button-list li a {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        user-select: none !important;
    }
}
</style>